import { IInitialState } from 'store/models';
import { moduleStateSelector } from '../../../selectors';

export function stateSelector(state: IInitialState) {
	return moduleStateSelector(state).templates;
}
